import { useParams } from "react-router-dom";
import { Form, Button, Input, message, Select } from "antd";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { apiClient } from "../Api/AllApi";
const Payment = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  // const product = Array.isArray(storeCustomer)
  //   ? storeCustomer.find((item) => item.id === parseInt(id))
  //   : null;
  const [amount_paid, setAmount_paid] = useState(0);
  const [form1] = Form.useForm();
  const [accountants, setAccountants] = useState([]);
  const [accountant, setAccountant] = useState(null);
  const [personName, setPersonName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // Loading state

  useEffect(() => {
    // Fetch accountants list from backend
    async function fetchAccountants() {
      try {
        const res = await apiClient.get("/accountants");
        let data = res.data;
        // Defensive: ensure data is always an array of objects with id and name
        if (!Array.isArray(data)) {
          if (data && typeof data === "object" && data.accountants) {
            // If backend returns { accountants: { ... } }
            data = Object.entries(data.accountants).map(([id, value]) => ({ id, ...value }));
          } else if (data && typeof data === "object") {
            // If backend returns just the object
            data = Object.entries(data).map(([id, value]) => ({ id, ...value }));
          } else {
            data = [];
          }
        }
        setAccountants(data);
      } catch (e) {
        setAccountants([]);
      }
    }
    fetchAccountants();
  }, []);

  // Function to handle form submission
  const PostApi = async () => {
    if (isSubmitting) return; // Prevent double submission
    setIsSubmitting(true);

    try {
      let formData = new FormData();
      formData.append("id", id); // Ensure ID is included
      formData.append("amount", amount_paid);
      formData.append("receiver", accountant); // accountant as receiver
      formData.append("sender", personName);   // personName as sender
      formData.append("payment_method", "cash"); // default to cash
      for (const pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      const res = await apiClient.post(`/customers/pay/${id}`, formData);
      form1.resetFields(); // Reset form on success
      // Get payment id from response
      const paymentId = res.data && res.data.payment ? res.data.payment.id : null;
      // Redirect to PaymentRecipt and pass customer id and payment id as params
      if (paymentId) {
        window.location.href = `/GetCustomer/PaymentRecipt/${id}/${paymentId}`;
      } else {
        window.location.href = `/GetCustomer/PaymentRecipt/${id}`;
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("error", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "50px",
        direction: "rtl", // Right-to-left layout for Arabic and Kurdish
      }}
    >
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("amountPaid")} {/* Translated heading */}
      </h1>
      <Form
        form={form1}
        onFinish={PostApi} // Trigger API on form submit
        style={{ fontSize: "18px" }}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          name="amount_paid"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("amountPaid")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            // placeholder={t("amountPaid")}
            value={amount_paid}
            onChange={(e) => setAmount_paid(e.target.value)}
          />
        </Form.Item>
        <Form.Item
          name="accountant"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("accountant")}
            </span>
          }
          rules={[{ required: true, message: t("Please select accountant") }]}
        >
          <Select
            showSearch
            placeholder={t("Select accountant")}
            value={accountant}
            onChange={setAccountant}
            style={{ width: "70%", fontSize: "16px" }}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {accountants.map((acc) => (
              <Select.Option key={acc.id} value={acc.name}>
                {acc.name} {acc.email ? `(${acc.email})` : ""}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="person_name"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("personName")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px" }}
            value={personName}
            onChange={(e) => setPersonName(e.target.value)}
            placeholder={t("Enter person name")}
          />
        </Form.Item>

        <Form.Item label=".">
          <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
            disabled={isSubmitting}
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            danger
            onClick={() => form1.resetFields()}
            style={{
              backgroundColor: "blue",
              borderColor: "blue",
              fontSize: "16px",
            }}
          >
            {t("reset")} {/* Translated button text */}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            danger
            onClick={() => (window.location.href = "/GetCustomer")}
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
          >
            {t("cancel")} {/* Translated button text */}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Payment;
